import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { useMemo } from 'react';

type PaddyBuyerSubDistrictResponse = AxiosResponse<
  {
    name: string;
  }[]
>;

const usePaddyBuyerSubDistrictList = (country: string) => {
  const query = useQuery<PaddyBuyerSubDistrictResponse>({
    queryKey: ['paddy-buyer-sub-district-list', country],
    queryFn: () =>
      API.get('/paddy-buyers/subdistrict/', { params: { country } }),
    enabled: !!country,
  });

  const paddyBuyerSubDistrictOptions = useMemo(() => {
    return query.data?.data?.map((data) => ({
      value: data.name,
      label: data.name,
    }));
  }, [query.data]);

  return { ...query, paddyBuyerSubDistrictOptions };
};

export default usePaddyBuyerSubDistrictList;
